module.exports = __webpack_public_path__ + "fonts/branch-zystoo-Regular-2.be2ffac0.otf";